// extracted by mini-css-extract-plugin
export default {"layout":"toast_layout__J2LmH","text":"toast_text__YLjR+"};